import React from 'react';
import useTheme from 'branding/theme';
import useLocalization from 'localization';
import withHover from '../../hocs/withHover';
import withFocus from '../../hocs/withFocus';
import useComponentMargin from '../../hooks/useComponentMargin';
import handleStickyFocus from '../../utils/handleStickyFocus';
export const Button = ({ className, onClick, children, type = 'button', variant = 'primary', size = 'regular', width = 'natural', disabled = false, noDefaultMargin = false, secondaryBorderColor, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleFocus, handleBlur, styles
// eslint-disable-next-line sonarjs/cognitive-complexity
 }) => {
    const { t } = useLocalization();
    const { borders, colors, inputs: { base, shape, size: inputSize, width: inputWidth, buttonStyles } } = useTheme();
    const marginStyles = useComponentMargin({ marginVertical: 'small' });
    const handleClick = handleStickyFocus(handleBlur, onClick);
    const mergedStyles = {
        ...base,
        ...buttonStyles.base,
        ...shape.pill,
        ...inputSize[size],
        ...inputWidth[width],
        ...buttonStyles.variant[variant],
        ...((isHovered || isFocused) && buttonStyles.hovered[variant]),
        ...(disabled && buttonStyles.disabled[variant]),
        ...(!noDefaultMargin && marginStyles),
        ...((isFocused || isHovered) &&
            variant === 'secondary' && { borderColor: colors.neutrals.transparent }),
        ...styles
    };
    const spanStyles = {
        ...borders.bottom,
        borderBottomColor: disabled
            ? colors.neutrals.borderAlpha
            : isFocused || isHovered
                ? colors.neutrals.transparent
                : secondaryBorderColor === 'primary'
                    ? colors.brand.primary.alpha
                    : colors.neutrals.textBeta
    };
    return (React.createElement("button", { className: className, type: type, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled, style: mergedStyles }, typeof children === 'string' ? (variant === 'secondary' ? (React.createElement("span", { style: spanStyles }, t(String(children)))) : (t(String(children)))) : (children)));
};
export default withHover(withFocus(Button));
//# sourceMappingURL=index.js.map